import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';

import { isAuthenticated } from '../reducers/analyticsApp';

const PrivateRoute = ({ authenticated, children }) => {
  const location = useLocation();

  return authenticated ? (
    children
  ) : (
    <Navigate
      to={{
        pathname: '/login',
        state: { from: location },
      }}
    />
  );
};

const mapStateToProps = (state, props) => ({
  ...props,
  authenticated: isAuthenticated(state),
});

export default connect(mapStateToProps)(PrivateRoute);
